import { CommonModule } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  forwardRef,
  input,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaModule } from 'primeng/textarea';
import { ShFormControl } from '../form-control/form-control.base';
import { primeSize } from '../models';

/**
 * Multi-line text input. `autoResize` grows it with its content.
 *
 *   <sh-textarea [(value)]="notes" [rows]="4" autoResize />
 */
@Component({
  selector: 'sh-textarea',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule, FormsModule, TranslateModule, TextareaModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShTextareaComponent),
      multi: true,
    },
  ],
  host: { class: 'sh-control', '[class.sh-invalid]': 'isInvalid()' },
  template: `
    <textarea
      pTextarea
      [ngModel]="value()"
      (ngModelChange)="commit($event)"
      [ngModelOptions]="{ standalone: true }"
      [attr.id]="controlId()"
      [attr.placeholder]="placeholder() | translate"
      [attr.aria-label]="ariaLabel() | translate"
      [attr.maxlength]="maxlength()"
      [rows]="rows()"
      [autoResize]="autoResize()"
      [readOnly]="isReadonly()"
      [disabled]="isDisabled()"
      [pSize]="pSize()"
      [fluid]="true"
      (blur)="markTouched()"
    ></textarea>
  `,
})
export class ShTextareaComponent extends ShFormControl<string> {
  readonly rows = input(3);
  readonly autoResize = input(false, { transform: booleanAttribute });
  readonly maxlength = input<number>();

  protected readonly pSize = computed(
    () => primeSize(this.size()) as 'small' | 'large'
  );
}
